import React from "react";
import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";
import { Paper, Grid } from "@material-ui/core";
import SemicLeft from "../../../components/m4k/semicItem/SemicLeft";
import Topbar from "../../../components/m4k/semicItem/topbar";
import SemicMid from "../../../components/m4k/semicItem/SemicMid";
import SemicRight from "../../../components/m4k/semicItem/SemicRight";
import { useHistory } from "react-router";

const semic_data = [
  "CMP抛光材料占比",
  "历年各地区半导体材料销售额",
  "中国光刻胶需求量，本土产量及均价",
  "全球半导体硅片行业竞争格局",
  "全球电子特气市场占比",
  "半导体市场",
  "半导体细分材料占比",
];
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    girdRoot: {
      width: "100vw",
      height: "100vh",
      boxSizing: "border-box",
      overflow: "hidden",
      color: "#64fffd",

      background:
        "linear-gradient(178deg,rgba(0,74,132,1) 0%,rgba(3,16,40,1) 100%)",
    },
    paper: {
      padding: theme.spacing(2),
      textAlign: "center",
      color: theme.palette.text.secondary,
    },
    gridItem: {
      height: "100%",
    },
  })
);

const Semic = () => {
  const classes = useStyles();
  document.title = "半导体材料";

  return (
    <Grid className={classes.girdRoot} container direction="row">
      <Grid item xs={12}>
        <Topbar />
      </Grid>
      <Grid item xs={4} className={classes.gridItem}>
        <SemicLeft />
      </Grid>
      <Grid item xs={4} className={classes.gridItem}>
        <SemicMid />
      </Grid>
      <Grid item xs={4} className={classes.gridItem}>
        <SemicRight />
      </Grid>
    </Grid>
  );
};

export default Semic;
